import React, { useState } from "react";

export default function ApplyForm({ jobTitle }) {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    message: "",
    resume: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    alert("Application submitted successfully!");
  };

  return (
    <div className="apply-form-wrapper">

      <h2>Apply for {jobTitle}</h2>

      <form className="apply-form" onSubmit={handleSubmit}>

        <div className="form-grid">

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter phone number"
              required
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Experience</label>
            <select name="experience" onChange={handleChange}>
              <option value="">Select Experience</option>
              <option>Fresher</option>
              <option>1 - 2 Years</option>
              <option>3 - 5 Years</option>
              <option>5+ Years</option>
            </select>
          </div>

        </div>

        <div className="form-group">
          <label>Cover Letter</label>
          <textarea
            name="message"
            rows="4"
            placeholder="Tell us about yourself"
            onChange={handleChange}
          />
        </div>

        <div className="form-group file-upload">
          <label>Upload Resume</label>
          <input
            type="file"
            name="resume"
            accept=".pdf,.doc,.docx"
            required
            onChange={handleChange}
          />
        </div>

        <button className="submit-btn">
          Submit Application
        </button>

      </form>
    </div>
  );
}